import { render, staticRenderFns } from "./Trustee.vue?vue&type=template&id=067d3332&"
import script from "./Trustee.vue?vue&type=script&lang=js&"
export * from "./Trustee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports